/**
 * Register all custom directives
 * Import and export directives to be registered in main.js
 */
import permission from './permission'

export default {
  install(app) {
    app.directive('permission', permission)
  }
}
